import request from "@/utils/request";

export function calculate(data) {
  return request({
    url: "/api/guaratee/calculation/calculate",
    method: "post",
    data
  });
}
export function getByCode(params) {
  return request({
    url: "/api/olGuaranteeProduct/getByCode",
    method: "get",
    params
  });
}

export function getBanner(params) {
  return request({
    url: "/api/operateBanner/list",
    method: "get",
    params
  });
}
export function ocrIdCard(params) {
  return request({
    url: "/api/olEnterprise/ocrIdCard",
    method: "get",
    params
  });
}
export function ocrBusiness(params) {
  return request({
    url: "/api/olEnterprise/ocrBusinessLicense",
    method: "get",
    params
  });
}

export default { calculate, getByCode, getBanner, ocrIdCard, ocrBusiness };
